export const ALL_LANGUAGES = ['en', 'pt'];

export const getCurrentLanguage = () => {
    const lang = localStorage.getItem('lang');
    // @ts-ignore
    const browserLanguage = navigator.language || navigator.browserLanguage || (navigator.languages || ALL_LANGUAGES)[0].split('-')[0];
    const currentLang = lang || browserLanguage.split('-')[0];

    if (ALL_LANGUAGES.includes(currentLang)) {
        return currentLang;
    }

    return ALL_LANGUAGES[0];
};

export const setCurrentLanguage = (lang: string, refresh = true) => {
    if (lang === getCurrentLanguage()) {
        return;
    }

    if (ALL_LANGUAGES.includes(lang)) {
        localStorage.setItem('lang', lang);

        if (refresh) {
            // eslint-disable-next-line no-restricted-globals
            location.reload();
        }
    }
};

export const loadLanguage = async (langKey: string) => {
    // eslint-disable-next-line import/no-dynamic-require, global-require
    const langFile = await require(`../lang/${langKey}.json`);
    if (!langFile) {
        throw new Error(`Language file ${langKey}.json not found`);
    }

    // @ts-ignore
    // eslint-disable-next-line no-underscore-dangle
    if (!window._DF) {
        // @ts-ignore
        // eslint-disable-next-line no-underscore-dangle
        window._DF = {};
    }

    // @ts-ignore
    // eslint-disable-next-line no-underscore-dangle
    window._DF[langKey] = langFile;
};

export const loadAllLanguages = () => {
    ALL_LANGUAGES.forEach(async (langKey) => {
        await loadLanguage(langKey);
    });
};

export const text = (key: string, params?: any) => {
    const lang = getCurrentLanguage();

    // @ts-ignore
    // eslint-disable-next-line no-underscore-dangle
    const entry = window._DF[lang][key] || window._DF.en[key] || key;

    if (!params) {
        return entry;
    }

    const keys = Object.keys(params);
    let filteredEntry = entry;

    for (let i = 0; i < keys.length; i += 1) {
        const paramKey = keys[i];
        const regex = new RegExp(`{${paramKey}}`, 'g');
        filteredEntry = filteredEntry.replace(regex, params[paramKey]);
    }

    return filteredEntry;
};
